<template>
  <div>
    <v-text-field v-if="!pickup"
                  :label="label({key: 'adds'})"
                  :value="address"
                  readonly
                  append-outer-icon="mdi-pencil"
                  @click:append-outer="gotoAddress"
    />
    <PointSelect v-else
                 v-model="pointMediator"
                 :points="points"
    >
      {{ $dictionary.get('select-from-points') }}
    </PointSelect>
    <v-row dense>
      <v-col v-for="field in fields" :key="field.key" :cols="field.cols">
        <v-checkbox v-if="field.type === 'checkbox'"
                    :error-messages="errors[field.key]"
                    :label="label(field)"
                    :false-value="false"
                    :true-value="true"
                    :value="values[field.key]"
                    @change="(value) => setValue(field.key, value)"
        />
        <v-text-field v-else
                      :error-messages="errors[field.key]"
                      :label="label(field)"
                      :value="values[field.key]"
                      @input="(value) => setValue(field.key, value)"
        />
      </v-col>
      <v-col v-if="paymentMethods.length">
        <v-select :items="paymentMethods"
                  :label="label({key: 'payment_method'})"
                  :value="values.payment_method"
                  item-text="label"
                  item-value="value"
                  @input="(value) => setValue('payment_method', value)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>

import PointSelect from '@/components/PointSelect';

export default {
  name: 'CheckoutForm',
  components: { PointSelect },
  props: {
    errors: { type: Object, default: () => ({}) },
    fields: { type: Array, default: () => [] },
    values: { type: Object, default: () => ({}) },
    address: { type: String, default: null },
    point: { type: [Number, String], default: 0 },
  },
  computed: {
    pointMediator: {
      get() {
        return this.point;
      },
      set(value) {
        this.$emit('update:point', value);
      },
    },
    points() {
      return [this.$store.state.data.point]; // this.$store.state.data.pointsInBasket;
    },
    pickup() {
      return this.$store.state.data.mode === 'pickup';
    },
    settings() { return this.$store.state.data.settings; },
    paymentMethods() {
      const keys = ['payment_cash', 'payment_card', 'payment_online', 'payment_robokassa'];
      const out = [];
      keys.forEach((value) => {
        if (this.settings[value]) {
          out.push({
            value, label: this.label({ key: value })
          });
        }
      });
      return out;
    }
  },
  methods: {
    label({ key, obligatory }) {
      const label = this.settings[`label_${key}`] || this.$dictionary.get(`order-${key}`);
      const star = obligatory ? '*' : '';
      return `${label}${star}`;
    },
    setValue(field, value) {
      this.$emit('input', { field, value });
    },
    gotoAddress() {
      this.$router.push({ name: 'address', params: { from: 'checkout' } });
    }
  }
};
</script>
